module.exports = __webpack_public_path__ + "static/img/1054.5baeaa9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1054.jpg
// module id = 236
// module chunks = 0